<template>
  <footer class="footer columns is-desktop">
    <div class="over-footer bg-primary">
      <p class="over-footer__text">
        Hoy es el día que esperabas para iniciar con nosotros la facturación
        electrónica ContaFácil tu mejor aliado
      </p>

      <div class="over-footer__action">
        <a
          rel="noopenner noreferer"
          class="button bg-primary-dark"
          href="https://app.contafacil.pe/#!/registro"
          @click="emitGlobalTriggerGtag('prueba_gratis')"
          >Prueba Gratis</a
        >
      </div>
    </div>
    <div class="footer__images column is-full-mobile is-one-quarter-desktop">
      <p class="text-logo">ContaFácil</p>
      <div class="footer__social-links">
        <div class="wrap-icon">
          <a
            href="https://www.youtube.com/@contafacil.p"
            target="_blank"
            rel="noopenner noreferer"
          >
            <youtube fillColor="#058B87" />
          </a>
        </div>
        <div class="wrap-icon">
          <a
            href="https://www.facebook.com/ContaFacil.pe"
            target="_blank"
            rel="noopenner noreferer"
          >
            <facebook fillColor="#058B87" />
          </a>
        </div>
        <div class="wrap-icon">
          <a
            href="https://twitter.com/ContaFacil_pe"
            target="_blank"
            rel="noopenner noreferer"
          >
            <twitter fillColor="#058B87" />
          </a>
        </div>
        <div class="wrap-icon">
          <a
            href="https://www.instagram.com/contafacil.pe"
            target="_blank"
            rel="noopenner noreferer"
          >
            <instagram fillColor="#058B87" />
          </a>
        </div>
        <div class="wrap-icon">
          <a
            href="https://www.linkedin.com/company/contaf%C3%A1cil/"
            target="_blank"
            rel="noopenner noreferer"
          >
            <linkedin fillColor="#058B87" />
          </a>
        </div>
        <div class="wrap-icon">
          <a
            href="https://www.tiktok.com/@contafacil.pe"
            target="_blank"
            rel="noopenner noreferer"
          >
            <tiktok fillColor="#058B87" />
          </a>
        </div>
      </div>
    </div>
    <div class="footer__sitemap  column is-half-desktop is-hidden-mobile">
      <ul class="link-list column">
        <li>
          <span><b>EMPRESA</b></span>
        </li>
        <li>
          <a @click="$router.push({ name: 'Home' })"><b>Inicio</b></a>
        </li>
        <li>
          <a @click="$router.push({ name: 'howitworks' })"
            ><b>Cómo funciona</b></a
          >
        </li>
        <li><a @click="$router.push({ name: 'plans' })">Planes</a></li>
        <li>
          <a @click="$router.push({ name: 'blog' })" v-if="false">Blog</a>
        </li>
        <li><a @click="$router.push({ name: 'contact' })">Contacto</a></li>
        <li>
          <a @click="$router.push({ name: 'support' })" v-if="false">Soporte</a>
        </li>
        <li>
          <a
            href="https://consultas.contafacil.pe/"
            target="_blank"
            rel="noopenner noreferer"
            >Consulta CPE</a
          >
        </li>
      </ul>
      <ul class="link-list column">
        <li>
          <span><b>MODULOS</b></span>
        </li>
        <li><a @click="$router.push({ name: 'sales' })">Ventas</a></li>
        <!-- <li>
          <a @click="$router.push({ name: 'marketrates' })">Cotizaciones</a>
        </li>
        <li>
          <a @click="$router.push({ name: 'referralguide' })"
            >Guías de Remisión</a
          >
        </li> -->
        <li>
          <a @click="$router.push({ name: 'client-provider' })"
            >Clientes y Proveedores</a
          >
        </li>
        <li>
          <a @click="$router.push({ name: 'expenses-purchases' })"
            >Gastos y Compras</a
          >
        </li>
        <li><a @click="$router.push({ name: 'inventory' })">Inventario</a></li>
        <li><a @click="$router.push({ name: 'reports' })">Reportes</a></li>
      </ul>
      <ul class="link-list column">
        <li>
          <span><b>POLÍTICAS</b></span>
        </li>
        <li>
          <a
            href="/files/T_C ContaFacil Usuarios Web. Tratamiento Necesario.pdf"
            download
            >Términos y Condiciones</a
          >
        </li>
        <li>
          <a
            href="/files/T_C ContaFacil Usuarios Web. Tratamiento Necesario.pdf"
            download
            >Políticas y Privacidad</a
          >
        </li>
        <li>
          <router-link to="libro-de-reclamaciones"
            >Libro de Reclamaciones</router-link
          >
        </li>
      </ul>
    </div>
    <div
      class="footer__iso column is-hidden-touch is-one-quarter-desktop is-one-fifth-fullhd"
    >
      <ul class="link-list column">
        <li>
          <span><b>ISO27001:2013</b></span>
        </li>
        <li>
          <a @click.stop="$router.push({ name: 'Iso' })"
            >Política de seguridad de la Información &#38; Alcance del
            Sistema</a
          >
        </li>
      </ul>
    </div>
    <div class="is-hidden-tablet footer-links-mobile">
      <details>
        <summary>EMPRESA</summary>
        <ul>
          <li>
            <a @click="$router.push({ name: 'Home' })">Inicio</a>
          </li>
          <li>
            <a @click="$router.push({ name: 'howitworks' })">Cómo funciona</a>
          </li>
          <li><a @click="$router.push({ name: 'plans' })">Planes</a></li>
          <li>
            <a @click="$router.push({ name: 'blog' })" v-if="false">Blog</a>
          </li>
          <li><a @click="$router.push({ name: 'contact' })">Contacto</a></li>
          <li>
            <a @click="$router.push({ name: 'support' })" v-if="false"
              >Soporte</a
            >
          </li>
        </ul>
      </details>
      <details>
        <summary>MÓDULOS</summary>
        <ul>
          <li><a @click="$router.push({ name: 'sales' })">Ventas</a></li>
          <li>
            <a @click="$router.push({ name: 'marketrates' })">Cotizaciones</a>
          </li>
          <li>
            <a @click="$router.push({ name: 'referralguide' })"
              >Guías de Remisión</a
            >
          </li>
          <li>
            <a @click="$router.push({ name: 'client-provider' })"
              >Clientes y Proveedores</a
            >
          </li>
          <li>
            <a @click="$router.push({ name: 'expenses-purchases' })"
              >Gastos y Compras</a
            >
          </li>
          <li>
            <a @click="$router.push({ name: 'inventory' })">Inventario</a>
          </li>
          <li><a @click="$router.push({ name: 'reports' })">Reportes</a></li>
        </ul>
      </details>
      <details>
        <summary>POLÍTICAS</summary>
        <ul>
          <li>
            <a
              href="/files/T_C ContaFacil Usuarios Web. Tratamiento Necesario.pdf"
              download
              >Términos y Condiciones</a
            >
          </li>
          <li>
            <a
              href="/files/T_C ContaFacil Usuarios Web. Tratamiento Necesario.pdf"
              download
              >Políticas y Privacidad</a
            >
          </li>
          <li>
            <router-link to="libro-de-reclamaciones"
              >Libro de Reclamaciones</router-link
            >
          </li>
        </ul>
      </details>
      <details>
        <summary>ISO27001:2013</summary>
        <ul>
          <li>
            <a @click.stop="$router.push({ name: 'Iso' })"
              >Política de seguridad de la Información &#38; Alcance del
              Sistema</a
            >
          </li>
        </ul>
      </details>
    </div>
  </footer>
</template>

<script>
import Twitter from "vue-material-design-icons/Twitter.vue";
import Facebook from "vue-material-design-icons/Facebook.vue";
import Instagram from "vue-material-design-icons/Instagram.vue";
import Youtube from "vue-material-design-icons/Youtube.vue";
import Linkedin from "vue-material-design-icons/Linkedin.vue";
import Tiktok from "./icons/IconTiktok.vue";
import { EventBus } from "@/event-bus";
export default {
  name: "TheFooter",
  components: {
    Twitter,
    Facebook,
    Instagram,
    Youtube,
    Linkedin,
    Tiktok
  },
  data() {
    return {
      innerMenu: false
    };
  },
  methods: {
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    }
  }
};
</script>

<style lang="scss">
@import "../assets/styles/general.scss";

.footer {
  position: relative;
  background-color: $primary-dark;
  padding: 0;
  margin: 0px;
  overflow: auto;

  // @include tablet() {
  //   padding-top: 12rem;
  // }
  // @include laptop() {
  //   padding-top: 7rem;
  // }
  // @media (min-width: 1024px){
  //   padding-top: 12rem;
  // }
  @include laptop() {
    overflow: visible;
    padding: 0 1rem;
    padding-top: 6rem;
  }

  &__images {
    // grid-column: 1 / 4;
    margin: 1rem auto !important;

    // max-width: 200px !important;
    .text-logo {
      font-weight: bold;
      font-size: 2rem;
      letter-spacing: 0.075em;
      color: #ffffff;
      margin-bottom: 1rem;
    }

    .footer__social-links {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      .wrap-icon {
        background-color: #ffffff;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        color: $primary-dark;
      }
    }

    @include tablet() {
      // grid-column: 1 / 4;

      .text-logo {
        font-size: 3rem;
        color: #ffffff;
      }

      .footer__social-links {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-items: center;
        gap: 1.5rem;
        .wrap-icon {
          background-color: #ffffff;
          width: 35px;
          height: 35px;
          border-radius: 50%;
          color: $primary-dark;

          .material-design-icon {
            font-size: 28px;
          }
        }
      }
    }

    @media (min-width: 1024px) {
      // grid-column: 1 / 4;

      .text-logo {
        font-size: 2rem;
        color: #ffffff;
      }

      .footer__social-links {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-items: center;
        gap: 1.5rem;
        .wrap-icon {
          background-color: #ffffff;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          color: $primary-dark;

          .material-design-icon {
            font-size: 2rem;
          }
        }
      }
    }

    @media (min-width: 1200px) {
      // grid-column: 1 / 4;

      .text-logo {
        font-size: 3rem;
        color: #ffffff;
      }

      .footer__social-links {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-items: center;
        gap: 1.5rem;
        .wrap-icon {
          background-color: #ffffff;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          color: $primary-dark;

          .material-design-icon {
            font-size: 2rem;
          }
        }
      }
    }
  }

  &__sitemap {
    grid-column: 4 / 10;
    display: flex;
    color: #ffffff;
    flex-flow: row nowrap;
    font-size: 12px;
    max-width: 100% !important;

    a {
      color: #ffffff;
      font-weight: 500;
    }

    @media (max-width: 767px) {
      flex-flow: row wrap;
      max-width: 100% !important;
    }

    @include tablet() {
      flex-flow: row nowrap;
      min-width: 75% !important;
    }

    @media (min-width: 1024px) {
      flex-flow: row nowrap;
      min-width: 50% !important;
    }
  }

  &__iso {
    grid-column: 10 / 13;
    color: #ffffff;
    flex-flow: row nowrap;
    font-size: 12px;
    max-width: 100% !important;

    a {
      color: #ffffff;
      font-weight: 500;
    }

    @media (max-width: 767px) {
      flex-flow: row wrap;
      max-width: 100% !important;
    }

    @include tablet() {
      flex-flow: row nowrap;
      // min-width: 75% !important;
    }

    @media (min-width: 1024px) {
      flex-flow: row nowrap;
      // min-width: 50% !important;
    }
  }

  .link-list {
    min-width: 33%;
    list-style-type: none;
    margin-bottom: 0px;

    li {
      text-align: start;
      position: relative;
      margin-bottom: 0px;

      span {
        font-size: 14px;
      }
    }

    @media (max-width: 767px) {
      min-width: 100%;
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      align-items: center;
      margin-top: 1rem;

      li {
        margin-right: 1rem;
      }
    }

    @include tablet() {
      margin-top: 1rem;

      li {
        margin-right: 1rem;

        a,
        span {
          font-size: 13px;
        }
      }
    }

    @media (min-width: 1024px) {
      margin-top: 1rem;

      li {
        margin-right: 1rem;

        a,
        span {
          font-size: 1rem;
        }
      }
    }

    @media (min-width: 1200px) {
      margin-top: 1rem;

      li {
        margin-right: 1rem;

        a,
        span {
          font-size: 1rem;
        }
      }
    }

    @media (min-width: 1400px) {
      margin-top: 1rem;

      li {
        margin-right: 1rem;

        a,
        span {
          font-size: 1rem;
        }
      }
    }

    @media (min-width: 1800px) {
      margin-top: 1rem;

      li {
        margin-right: 1rem;

        a,
        span {
          font-size: 1.5rem;
        }
      }
    }
  }
}

.over-footer {
  // position: absolute;
  // top: -60px;
  // left: 15%;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-around;
  align-items: center;
  padding: 2rem 1rem;

  &__text {
    color: #ffffff;
    text-align: center;
    font-size: 15px;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .button {
    margin-top: 1rem;
    margin-bottom: 0px !important;
    font-size: 12.2px;
    border-radius: 6.71px;
  }

  @include tablet() {
    // position: absolute;
    // top: -65px;
    // left: 13%;
    // width: 74%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-around;
    align-items: center;
    padding: 2rem 1rem;

    &__text {
      color: #ffffff;
      text-align: center;
      margin-bottom: 0px;
      font-size: 1rem;
      font-weight: 600;
      padding: 0 2%;
    }

    &__action {
      margin: 0 auto;
    }

    .button {
      margin-bottom: 0px !important;
      margin: 1em auto 0;
      // margin: 0 1rem 0 3rem;
      font-size: 1rem !important;
      // width: 260px;
    }
  }

  @media (min-width: 1024px) {
    position: absolute;
    top: -50px;
    left: 13%;
    width: 74%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
    padding: 2rem 1rem;

    &__text {
      color: #ffffff;
      text-align: start;
      margin-bottom: 0px;
      font-size: 16px;
      font-weight: 600;
      padding: 0 2%;
    }

    &__action {
      margin: 0 2%;
    }

    .button {
      margin-bottom: 0px !important;
      margin-top: 0px !important;
      // margin: 0 1rem 0 3rem;
      font-size: 16px !important;
      // width: 260px;
    }
  }

  @media (min-width: 1440px) {
    position: absolute;
    top: -50px;
    left: 23.5%;
    width: 53%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
    padding: 2rem 1rem;

    &__text {
      color: #ffffff;
      text-align: start;
      margin-bottom: 0px;
      font-size: 16px;
      font-weight: 600;
      padding: 0 8%;
    }

    &__action {
      margin: 0 8%;
    }

    .button {
      margin-bottom: 0px !important;
      // margin: 0 1rem 0 3rem;
      font-size: 16px !important;
      // width: 260px;
    }
  }

  @media (min-width: 1800px) {
    position: absolute;
    top: -50px;
    left: 20%;
    width: 60%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
    padding: 2rem 1rem;

    &__text {
      color: #ffffff;
      text-align: start;
      margin-bottom: 0px;
      font-size: 1.2rem;
      font-weight: 600;
      padding: 0 8%;
    }

    &__action {
      margin: 0 8%;
    }

    .button {
      margin-bottom: 0px !important;
      // margin: 0 1rem 0 3rem;
      font-size: 1.2rem !important;
      // width: 260px;
    }
  }
}

.footer-links-mobile {
  width: 95%;
  margin: 0 auto;
  color: #ffffff;
  overflow: scroll;

  details {
    padding: 1em;
    border-bottom: thin solid #f0f0f0;

    ul {
      li {
        text-align: start;
        padding: 0.2em 0;

        a {
          color: #ffffff;
          font-size: 1rem;
          letter-spacing: 0.025em;
        }
      }
    }
  }

  summary {
    text-align: start;
    font-weight: bold;
    letter-spacing: 0.075em;

    &:focus {
      outline: none;
    }
  }

  summary::-webkit-details-marker {
    display: none;
  }

  summary:after {
    float: right;
    height: 20px;
    width: 20px;
    content: "\2304";
    font-size: 2rem;
    color: #ffffff;
    margin-top: -20px;
  }

  details[open] summary:after {
    content: "\2303";
    margin-top: -5px;
  }
}
</style>
